module.exports = __webpack_public_path__ + "img/couples_14_V.df802b69.webp";